import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import StepRoutes from "../../../Routes/steps_routes";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import performRequest from "../../../api/request";
import { Form, Formik } from "formik";
import Footer from "../../../Components/Footer/footer";
import CustomSelect from "../../../CustomComponent/custom_select";
import { useSelector } from "react-redux";
import LoadingPage from "../../../Components/layouts/loading";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { socialMediaPlanInfo } from "../../../SchemaInfo/info";
import { socialMediaPlanSchema } from "../../../Schemas/Media And Marketing/socialMediaPlan.schema";
import { FcCalendar } from "react-icons/fc";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import axios from "axios";

const AddSchedule = () => {
  const store = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const [showPages, setShowPages] = useState(false);
  const [showDays, setShowDays] = useState(false);
  const dropdownRef = useRef(null);
  const dayDropdownRef = useRef(null);

  const navigate = useNavigate();

  const today = new Date().toISOString().split("T")[0];

  const weekDays = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowPages(false);
      }

      if (
        dayDropdownRef.current &&
        !dayDropdownRef.current.contains(event.target)
      ) {
        setShowDays(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handelSubmit = async (values) => {
    values = {
      ...values,
      editor: store?.UserId,
      time: values.time ? `${values.time}:00` : "",
    };

    console.log("Form Values:", values);

    setLoading(true);

    performRequest("POST", `/postPlanning/createPostingSchedule/`, values)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Social Medial Plan Created Successfully!");
          navigate(`/media-posting`);
        } else {
          Toast("error", "Error while creating podcast");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcCalendar className="fs-2 me-1" />
                  Create Social Media Plan
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title ">Create New Social Media Plan</h2>
            </div>
            <Formik
              initialValues={socialMediaPlanInfo}
              validationSchema={socialMediaPlanSchema}
              onSubmit={handelSubmit}
              enableReinitialize={true}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Topic Name
                      </label>

                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="scheduleName"
                        />
                        {props.touched.scheduleName &&
                          props.errors.scheduleName && (
                            <p className="text-danger mt-1">
                              {props.errors.scheduleName}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Asset Name
                      </label>
                      <div className="w-100 col">
                        <CustomSelect name="pageName" className="form-control">
                          <option value="">Select</option>
                          <option value="Kryzen Biotech">
                            Kryzen Biotech{" "}
                          </option>
                          <option value="Hydroponic Masterclass">
                            Hydroponic Masterclass
                          </option>
                          <option value="Open Talk With Sudhir Devkar">
                            Open Talk With Sudhir Devkar
                          </option>
                          <option value="Eat Pure Greens">
                            Eat Pure Greens
                          </option>
                          {/* <option value="Sudhir Devkar Marathi Clips">
                            Sudhir Devkar Marathi Clips
                          </option>
                          <option value="Sudhir Devkar Marathi Clips">
                            Sudhir Devkar Hindi Clips
                          </option> */}
                        </CustomSelect>

                        {props.touched.pageName && props.errors.pageName && (
                          <p className="text-danger">
                            {" "}
                            {props.errors.pageName}{" "}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Content Type
                      </label>
                      <div className="w-100 col">
                        <CustomSelect name="contentType">
                          <option value="">Select</option>
                          {[
                            "Reel",
                            "Story",
                            "Post",
                            "Carousel",
                            // "Podcast",
                            // "Podcast Clip",
                            // "Informative Video",
                          ]?.map((item, index) => (
                            <option key={index} value={item}>
                              {item}
                            </option>
                          ))}
                        </CustomSelect>
                        {props.touched.contentType &&
                          props.errors.contentType && (
                            <p className="text-danger mt-1">
                              {props.errors.contentType}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Format</label>
                      <div className="w-100 col">
                        <CustomSelect name="format">
                          <option value="">Select</option>
                          {[
                            "Image 4:5",
                            "Reels / Shorts 9:16",
                            "Video 16:9",
                            "Story 9:16",
                            "Images Set 4:5",
                            "Paragraphs",
                            "Image / Video",

                            // "Podcast",
                            // "Podcast Clip",
                            // "Informative Video",
                          ]?.map((item, index) => (
                            <option key={index} value={item}>
                              {item}
                            </option>
                          ))}
                        </CustomSelect>
                        {props.touched.format && props.errors.format && (
                          <p className="text-danger mt-1">
                            {props.errors.format}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Start Date
                      </label>

                      <div className="w-100 col">
                        <CustomInput
                          type="date"
                          className="form-control"
                          name="startDate"
                          min={today}
                        />
                        {props.touched.startDate && props.errors.startDate && (
                          <p className="text-danger mt-1">
                            {props.errors.startDate}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">End Date</label>

                      <div className="w-100 col">
                        <CustomInput
                          type="date"
                          className="form-control"
                          name="endDate"
                          min={props.values.startDate || today}
                          onChange={(e) => {
                            props.setFieldValue("endDate", e.target.value);

                            if (!e.target.value) {
                              props.setFieldValue("days", []);
                              setShowDays(false);
                            }
                          }}
                        />
                      </div>
                    </div>

                    {props.values.endDate && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">Days</label>

                        <div
                          className="w-100 col position-relative"
                          ref={dayDropdownRef}
                        >
                          <div
                            className="form-select"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setShowDays((prev) => !prev);
                              props.setFieldTouched("days", true);
                            }}
                          >
                            {props.values.days?.length === weekDays.length
                              ? "Every Day"
                              : props.values.days?.length > 2
                              ? `${props.values.days.length} Days Selected`
                              : props.values.days.join(", ") || "Select Day(s)"}
                          </div>

                          {showDays && (
                            <div
                              className="border rounded p-2 bg-white shadow"
                              style={{
                                position: "absolute",
                                zIndex: 1000,
                                width: "100%",
                                maxHeight: "250px",
                                overflowY: "auto",
                              }}
                            >
                              {["Every Day", ...weekDays].map((day) => (
                                <div className="form-check" key={day}>
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`day-${day}`}
                                    checked={
                                      day === "Every Day"
                                        ? weekDays.every((d) =>
                                            props.values.days.includes(d)
                                          )
                                        : props.values.days.includes(day)
                                    }
                                    onChange={(e) => {
                                      if (day === "Every Day") {
                                        props.setFieldValue(
                                          "days",
                                          e.target.checked ? [...weekDays] : []
                                        );
                                        return;
                                      }

                                      let updatedDays = [...props.values.days];

                                      if (e.target.checked) {
                                        if (!updatedDays.includes(day)) {
                                          updatedDays.push(day);
                                        }
                                      } else {
                                        updatedDays = updatedDays.filter(
                                          (item) => item !== day
                                        );
                                      }

                                      props.setFieldValue("days", updatedDays);
                                    }}
                                  />

                                  <label
                                    className={`form-check-label ${
                                      day === "Every Day" ? "fw-bold" : ""
                                    }`}
                                    htmlFor={`day-${day}`}
                                  >
                                    {day}
                                  </label>
                                </div>
                              ))}
                            </div>
                          )}
                          {props.values.endDate &&
                            props.touched.days &&
                            props.errors.days && (
                              <p className="text-danger mt-1">
                                {props.errors.days}
                              </p>
                            )}
                        </div>
                      </div>
                    )}

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Time</label>
                      <div className="w-100 col">
                        <CustomInput
                          type="time"
                          className="form-control"
                          name="time"
                        />
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Platforms</label>

                      <div className="w-100 col">
                        {[
                          "instagram",
                          "facebook",
                          "youtube",
                          "linkdin",
                          "X.com",
                          "Threads",
                        ].map((platform) => (
                          <div className="form-check" key={platform}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={platform}
                              checked={props.values.platforms.includes(
                                platform
                              )}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  props.setFieldValue("platforms", [
                                    ...props.values.platforms,
                                    platform,
                                  ]);
                                } else {
                                  props.setFieldValue(
                                    "platforms",
                                    props.values.platforms.filter(
                                      (p) => p !== platform
                                    )
                                  );
                                }
                              }}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={platform}
                            >
                              {platform.charAt(0).toUpperCase() +
                                platform.slice(1)}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        File Format
                      </label>
                      <div className="w-100 col">
                        <CustomSelect name="fileFormat">
                          <option value="">Select</option>

                          <option value="Image">Image</option>

                          <option value="Video">Video</option>

                          {props.values.format === "Post" && (
                            <option value="MultipleImage">
                              Multiple Image
                            </option>
                          )}
                        </CustomSelect>
                      </div>
                    </div> */}

                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3">File Path</label>
                      <div className="w-100 col">
                        <CustomInput
                          type="file"
                          disabled={!props.values.fileFormat}
                          multiple={props.values.fileFormat === "MultipleImage"}
                          accept={
                            props.values.fileFormat === "Image"
                              ? "image/*"
                              : props.values.fileFormat === "Video"
                              ? "video/*"
                              : props.values.fileFormat === "MultipleImage"
                              ? "image/*"
                              : ""
                          }
                          onChange={(e) => {
                            const files = Array.from(e.target.files);

                            if (props.values.fileFormat === "MultipleImage") {
                              if (files.length > 10) {
                                Toast("error", "Maximum 10 images allowed");
                                return;
                              }

                              const invalidFile = files.find(
                                (file) => !file.type.startsWith("image/")
                              );

                              if (invalidFile) {
                                Toast("error", "Only images are allowed");
                                return;
                              }

                              props.setFieldValue("filepath", files);
                            } else {
                              props.setFieldValue("filepath", files[0]);
                            }
                          }}
                        />
                        {!props.values.fileFormat && (
                          <p className="text-warning mt-1">
                            Please select File Format first
                          </p>
                        )}
                      </div>
                    </div> */}

                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Upload Thumbnail
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name=""
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "uploadThumbnail",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.uploadThumbnail &&
                          props.errors.uploadThumbnail && (
                            <p className="text-danger">
                              {props.errors.uploadThumbnail}
                            </p>
                          )}
                      </div>
                    </div> */}

                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Topic</label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"text"}
                          className="form-control"
                          name="topic"
                        ></CustomInput>
                        {props.touched.topic && props.errors.topic && (
                          <p className="text-danger"> {props.errors.topic} </p>
                        )}
                      </div>
                    </div> */}

                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Video Script{" "}
                      </label>
                      <div className="w-100 col">
                        <CustomTextArea
                          type={"text"}
                          className="form-control"
                          name="description"
                        ></CustomTextArea>
                        {props.touched.description &&
                          props.errors.description && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.description}{" "}
                            </p>
                          )}
                      </div>
                    </div> */}
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Create New Social Media Plan" />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};
export default AddSchedule;
